import { useParams, useSearchParams } from "react-router";

import type { CardProfileType } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/types/CardProfileType";
import { PromptDataEditForm } from "src/app/features/ApplicationProfile/subFeatures/PromptData/components/forms/PromptDataEditForm";
import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../../../components/FeatureButtons/CancelButton";
import { HistoryButton } from "../../../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../../../core/router/auth";
import { ResourceName } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";

export const PromptDataEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();

    const { appProfileId, cardProfId, id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/app-profiles/${appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${cardProfId}/prompt-data-configs/${id}/${FORM_ACTION.HISTORY}`;

    const [searchParams] = useSearchParams();
    const type = searchParams.get("type") as CardProfileType;

    const backUrl = `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION_EFT4F}/${FORM_ACTION.EDIT}/${cardProfId}?type=${type}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.promptDataEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton isDisabled={false} url={backUrl} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <PromptDataEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
